/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

/**
 * @module LogsModule
 */

import { Component } from '@angular/core';
import { L10nService } from '@vmw/ngx-vip';
import * as globalL10n from 'global-l10n';

import { TrafficLogListExpandedContentStore } from '../traffic-log-list-expanded-content.store';
import { ITrafficLogsStates, TrafficLogsStore } from '../../traffic-logs.store';
import { VsAppProfileType } from '../../../../logs.types';

import * as l10n from './traffic-log-list-expanded-content-communicating-ips.component.l10n';
import './traffic-log-list-expanded-content-communicating-ips.component.less';

const { ...globalL10nKeys } = globalL10n;
const { ENGLISH: dictionary, ...l10nKeys } = l10n;

/**
 * @description
 *     Component used for showing the communicating IPs in the traffic log list expanded content.
 * @author Zhiqian Liu
 */
@Component({
    selector: 'traffic-log-list-expanded-content-communicating-ips',
    templateUrl: 'traffic-log-list-expanded-content-communicating-ips.component.html',
})
export class TrafficLogListExpandedContentCommunicatingIpsComponent {
    public readonly globalL10nKeys = globalL10nKeys;

    public readonly l10nKeys = l10nKeys;

    public readonly vsAppProfileType$ = this.trafficLogsStore.vsAppProfileType$;

    public readonly VsAppProfileType = VsAppProfileType;

    public readonly defaultVsIp$ = this.trafficLogsStore.defaultVsIp$;

    public readonly clientRtt$ = this.trafficLogListExpandedContentStore.clientRtt$;

    public readonly serverRtt$ = this.trafficLogListExpandedContentStore.serverRtt$;

    public readonly responseCode$ = this.trafficLogListExpandedContentStore.responseCode$;

    public readonly serverResponseCode$ = this.trafficLogListExpandedContentStore.serverResponseCode$;

    public readonly appResponseTime$ = this.trafficLogListExpandedContentStore.appResponseTime$;

    public readonly dataTransferTime$ = this.trafficLogListExpandedContentStore.dataTransferTime$;

    public readonly totalTime$ = this.trafficLogListExpandedContentStore.totalTime$;

    public readonly clientIps$ = this.trafficLogListExpandedContentStore.clientIps$;

    public readonly clientSrcPort$ = this.trafficLogListExpandedContentStore.clientSrcPort$;

    public readonly clientDestPort$ = this.trafficLogListExpandedContentStore.clientDestPort$;

    public readonly vsIps$ = this.trafficLogListExpandedContentStore.vsIps$;

    public readonly serverIps$ = this.trafficLogListExpandedContentStore.serverIps$;

    public readonly serverSrcPort$ = this.trafficLogListExpandedContentStore.serverSrcPort$;

    public readonly serverDestPort$ = this.trafficLogListExpandedContentStore.serverDestPort$;

    public readonly sourceIps$ = this.trafficLogListExpandedContentStore.sourceIps$;

    public readonly serverConnectionSrcIps$ =
        this.trafficLogListExpandedContentStore.serverConnectionSrcIps$;

    public readonly serviceEngine$ = this.trafficLogListExpandedContentStore.serviceEngine$;

    public readonly vcpuId$ = this.trafficLogListExpandedContentStore.vcpuId$;

    public readonly pool$ = this.trafficLogListExpandedContentStore.pool$;

    public readonly poolName$ = this.trafficLogListExpandedContentStore.poolName$;

    public readonly serverName$ = this.trafficLogListExpandedContentStore.serverName$;

    constructor(
        l10nService: L10nService,
        private readonly trafficLogsStore: TrafficLogsStore<ITrafficLogsStates>,
        public readonly trafficLogListExpandedContentStore: TrafficLogListExpandedContentStore,
    ) {
        l10nService.registerSourceBundles(dictionary);
    }
}
